module.exports = require('../../lms/zero/fmt.js');
